<script>
    // 허브 접근 설정 — '로그인해야 둘러볼 수 있게 잠글지'. 봇 빌더 [설정] 탭에 얹힌다.
    //
    // 왜 설정 탭인가: 화면에 뭐가 그려지느냐가 아니라 **누가 들어올 수 있느냐**다.
    // 예전엔 [채팅] 탭에 있었는데, 그 탭은 격자 저작이라 성격이 달랐다.
    //
    // ⚠️ 저장은 setHubSettings 다. setHubChats 는 격자를 통째로 교체하는 저장이라
    //    chats 없이 부르면 격자가 전부 지워진다.
    import { onDestroy, onMount } from "svelte";
    import { PRConnect } from "@projectroom/ui-lib";
    import { Switch } from "../../lib/ui";
    import { markSaving, markSaved } from "../store/builder-store.js";

    export let bot;

    let loginRequired = false;
    let loaded = false;
    let error = "";
    let saveTimer;

    onMount(() => {
        PRConnect.send("/api/HubSetup/getHubChats", { botId: bot.id }, (data) => {
            loginRequired = !!data.result?.loginRequired;
            loaded = true;
        }, () => { loaded = true; });
    });

    const toggle = () => {
        loginRequired = !loginRequired;
        clearTimeout(saveTimer);
        saveTimer = setTimeout(() => {
            error = "";
            markSaving();
            PRConnect.send("/api/HubSetup/setHubSettings", { botId: bot.id, loginRequired },
                () => markSaved(),
                (err) => { markSaved(); error = err.header?.message || "저장하지 못했습니다."; });
        }, 400);
    };

    onDestroy(() => clearTimeout(saveTimer));
</script>

{#if loaded}
    <div class="tw-mb-6 tw-rounded-lg tw-border tw-border-border tw-p-4">
        <h3 class="tw-mb-0 tw-text-sm tw-font-semibold tw-text-foreground">허브 접근</h3>
        <label class="tw-mb-0 tw-mt-3 tw-flex tw-items-center tw-gap-2 tw-text-sm tw-font-normal">
            <Switch checked={loginRequired} on:click={toggle} />
            로그인해야 둘러볼 수 있게 잠그기
        </label>
        <p class="tw-mb-0 tw-mt-2 tw-text-xs tw-text-muted-foreground">
            잠그면 로그인 전에는 채팅 목록이 보이지 않습니다.
            ⚠️ 이건 <b>둘러보기를 막는 화면 장치</b>입니다 — 채팅 주소를 아는 사람은 여전히 열 수 있습니다.
        </p>
        {#if error}<p class="tw-mb-0 tw-mt-2 tw-text-sm tw-text-destructive">{error}</p>{/if}
    </div>
{/if}
